import { mapState } from 'vuex'

export default {
  computed: mapState({
    currentRouteParameters: state => state.navigation.current.params,
    previousRouteParameters: state => state.navigation.previous.params
  }),

  methods: {
    isCurrentRoute (name) {
      return this.$store.getters.isCurrentRoute(name)
    },
    isPreviousRoute (name) {
      return this.$store.getters.isPreviousRoute(name)
    }
  }
}
